import { render, staticRenderFns } from "./estadisticas.vue?vue&type=template&id=aecd6ea4&scoped=true&"
import script from "./estadisticas.vue?vue&type=script&lang=ts&"
export * from "./estadisticas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aecd6ea4",
  null
  
)

export default component.exports